export default (state = {}, action) => {
  switch (action.type) {
    case "SETTINGS/VERSION/UP": {
      return {
        ...state,
        lock_version: action.payload
      };
    }
    default: {
      return state;
    }
  }
};
